import React from "react";
import styles from "./page.default.module.css";
import { useTranslation } from "react-i18next";

const About: React.FC = () => {
  const { t } = useTranslation();
  return (
    <section className={styles.pageSection}>
      <div className={styles.container}>
        <div className={styles.heading}>
          <h1 className={styles.title}>{t("about.title")}</h1>
          <p className={styles.description}>{t("about.description")}</p>
        </div>
      </div>
    </section>
  );
};

export default About;
